export default __webpack_public_path__ + "static/media/Screen_Infrastructure_04_03-end.e1ad0469.jpg";